(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["search-inspiration"] && !Shopify.designMode) return;
  try {
    
function initYcDiscovery(){document.querySelectorAll('[data-yc-discovery]:not([data-ready])').forEach(section=>{const grid=section.querySelector('.yc-discovery-grid');const cards=Array.from(grid.children);const button=section.querySelector('.yc-discovery-shuffle');const show=()=>{const pool=cards.slice();for(let i=pool.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[pool[i],pool[j]]=[pool[j],pool[i]];}cards.forEach(card=>card.hidden=true);pool.slice(0,4).forEach(card=>{card.hidden=false;grid.append(card);});};show();section.dataset.ready='true';if(cards.length>4){button.hidden=false;button.addEventListener('click',show);}});}
initYcDiscovery();document.addEventListener('DOMContentLoaded',initYcDiscovery);document.addEventListener('shopify:section:load',initYcDiscovery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-brands-sephora"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = value => (value || '').toLocaleLowerCase().normalize('NFKD').replace(/[\u0591-\u05C7]/g, '').replace(/[^a-z0-9\u0590-\u05ff]+/g, ' ').trim();
    document.querySelectorAll('[data-yc-brands]').forEach(root => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const input = root.querySelector('[data-yc-brand-search]');
      const cards = [...root.querySelectorAll('.yc-brand-card')];
      const groups = [...root.querySelectorAll('.yc-brand-group')];
      const empty = root.querySelector('[data-yc-brand-empty]');
      input.addEventListener('input', () => {
        const query = normalize(input.value);
        let visible = 0;
        cards.forEach(card => {
          const show = !query || normalize(card.dataset.search).includes(query);
          card.hidden = !show;
          if (show) visible += 1;
        });
        groups.forEach(group => {
          group.hidden = !group.querySelector('.yc-brand-card:not([hidden])');
        });
        empty.style.display = visible ? 'none' : 'block';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
